import { render, staticRenderFns } from "./OrderIds.vue?vue&type=template&id=43eab97b&"
import script from "./OrderIds.vue?vue&type=script&lang=js&"
export * from "./OrderIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports